module.exports = __webpack_public_path__ + "img/recommendation.78e215f5.svg";